import arrayToIdIndex from "@/client/helpers/arrayToIdIndex";

export const PAYMENT_TARGET_CHARGE = 1;
export const PAYMENT_TARGET_FINE = 2;

export const paymentTargets = [
  { name: 'Начисления', id: PAYMENT_TARGET_CHARGE },
  { name: 'Пени', id: PAYMENT_TARGET_FINE },
];

export const paymentTargetsDict = arrayToIdIndex(paymentTargets);
